export const domainsJson = {
  // kuwait: "http://localhost:3001",
  kuwait: "https://kuwaitpack.com",
  uae: "https://upak.ae",
  jeddah: "https://spak.sa",
};

export const brandNamesJson = {
  kuwait: "K-PAK",
  uae: "U-PAK",
  jeddah: "S-PACK",
}

export const brandData = [
  {
    id: 1,
    slug: "kuwait",
    title: "K-PAK – KUWAIT",
    links: [
      {
        name: "International Sales - Ms. Simran Kapoor",
        phone: "+965 24721124 Ext - 114",
        mob: "+965 60673659 / +965 97682561",
        email: "simran@kuwaitpack.com",
      },
      {
        name: "Kuwait & Iraq Sales - Ms. Premilla Dsouza",
        phone: "+24721124 Ext 118",
        mob: "+965 66922889",
        email: "kpaksales@kuwaitpack.com",
      },
    ],
    whatsapp: "+96560673659",
    facebook: "https://www.facebook.com/kpakmfgcoksc?",
    twitter: "https://twitter.com/kuwaitpack",
    instagram: "https://www.instagram.com/kwtpak/profilecard/?igsh=NzZuMzd0Y2o2czFj",
    path: "/kuwait",
  },
  {
    id: 2,
    slug: "jeddah",
    title: "S-PAK - KSA",
    links: [
      {
        name: "Mr. Ikramullah Abid",
        phone: "+966 13 8122080/1/2",
        mob: "+966 59 3433612",
        email: "ikram@spak.sa",
      },
    ],
    whatsapp: "+966593433612",
    twitter: "https://twitter.com/kuwaitpack",
    facebook: "https://www.facebook.com/profile.php?id=61573799570235",
    instagram: "https://www.instagram.com/spak_industries?igsh=MXZmcGN4eG5maDR6eQ==",
    path: "/ksa",
  },
  {
    id: 3,
    slug: "uae",
    title: "U-PAK Industries - UAE",
    links: [
      {
        name: "Mr. Hamid Anwar",
        phone: "+971 7 244 7950",
        mob: "+971 50 115 2662",
        email: "hamid@upak.ae",
      },
    ],
    whatsapp: "+971501152662",
    twitter: "https://twitter.com/kuwaitpack",
    facebook: "https://www.facebook.com/profile.php?id=61573724634132",
    instagram: "https://www.instagram.com/upak.industries?igsh=bTltaTIxYzgxdG1z&utm_source=qr",
    path: "/uae",
  },
];
